module.exports = __webpack_public_path__ + "img/img27.49cc5a4f.svg";